export const Chips = ({
	type = "Primary",
	size = "Medium",
	label = "",
	className = "",
}) => {
	return (
		<div
			className={`${
				type === "Primary"
					? "bg-black text-color-White"
					: type === "Secondary"
						? "bg-color-Secondary300 text-[#54A9A5]"
						: type === "Tertiary"
							? "bg-color-Grey50 text-[#333]"
							: type === "Grey"
								? "bg-color-Grey50 text-color-Grey700"
								: type === "Blue"
									? "bg-color-Blue50 text-color-Blue500"
									: type === "Outline"
										? `border-[1px] ${className}`
										: "border-[1px] border-color-Grey700 text-[#666]"
			}
        ${size === "Small" ? "ButtonS" : "ButtonM"}
        inline-flex rounded-md py-[4px] px-[8px]`}
		>
			{label}
		</div>
	);
};
